import React, { useState } from "react";
import { Check, Share2 } from "lucide-react";
import { useDialog } from "contexts/DialogContext";
import { useI18n } from "i18n";
import { shareUrl } from "lib/share";

/**
 * Compartilha uma foto pela sua URL canonica: `/photo/<uuid>`.
 *
 * E essa URL — e nao a do arquivo — que deve circular: quando um crawler de
 * rede social a abre, o backend responde com `og:image` / `twitter:image:src`
 * apontando para a foto, entao o link renderiza com a previa correta.
 *
 * Usa a Web Share API quando existe (celular); senao copia para a area de
 * transferencia. O link leva `?ts=` do momento do clique (`lib/share.js`).
 */
export default function ShareButton({ photoId, title, className = "" }) {
  const { t } = useI18n();
  const { alert } = useDialog();
  const [copied, setCopied] = useState(false);

  const share = async () => {
    const url = shareUrl(`/photo/${photoId}`);
    if (navigator.share) {
      try {
        await navigator.share({ title: title || document.title, url });
        return;
      } catch {
        // Cancelado pelo usuario ou indisponivel: caimos na copia abaixo.
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Sem clipboard (contexto inseguro, permissao negada): mostramos a URL no
      // modal do proprio sistema — nunca um popup nativo do navegador.
      await alert({
        title: t("public.photo.share"),
        description: url,
        variant: "info",
      });
    }
  };

  return (
    <button
      type="button"
      onClick={share}
      className={`inline-flex items-center gap-2 rounded-full bg-amber-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-amber-600 ${className}`}
    >
      {copied ? <Check size={16} /> : <Share2 size={16} />}
      {copied ? t("common.copied") : t("public.photo.share")}
    </button>
  );
}
